import React, { useRef, useState, useEffect } from "react";
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  TextField,
  Button,
  Icon,
  Dialog,
  CardActionArea,
} from "@mui/material";
import { Modal } from "react-responsive-modal";
// import AddDeliveryBoy from "./addDeliveryBoy";
// import CovidVaccinationReport from "./CovidVaccinationReport";
import MainTable from "../../../components/Table/PaginationTable";
import { useDispatch, useSelector } from "react-redux";
import { DROPPOINTCOLUMNS, MANAGERCOLUMNS, VEHICLECOLUMNS } from "../../Orders/columns/columnDef";
import { useTranslation } from "react-i18next";
import {
  fetchDeliveryManagers,
  fetchDropPoints,
  fetchVehicles,
} from "../../../redux/deliverySlice";

const DropPoints = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [pageNumber, setPageNumber] = useState(1); //  1-based indexing
  const [pageSize, setPageSize] = useState(10);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const tableData =
    useSelector((state) => state.deliveryModule.dropPointDetails) || [];
  const totalRecords = useSelector(
    (state) => state.deliveryModule.paginationInfo.totalRecords
  );

  // useSelector((state) => state.order.paginationInfo?.totalRecords) || 0;

  const [editData, setEditData] = useState(null);
  const [covidVacineR, setCovidVacineR] = useState(null);
  const tableRef = useRef();
  const covidVaccineData = [];
  useEffect(() => {
    dispatch(fetchDropPoints());
  }, [dispatch, pageSize, pageNumber]);
  const onCloseModal = () => {
    setOpen(false);
  };
  const handleOpenModal = () => {
    // model popup
    setOpen(true);
  };

  const onCloseModal2 = () => {
    setOpen2(false);
  };
  const handleOpenModal2 = () => {
    // model popup
    setOpen2(true);
  };
  const covidmodel = ({ row }) => {
    setCovidVacineR(row.values);
    handleOpenModal2();
  };
  const handleFilterSearch = () => {};

  const view = ({ row }) => {
    //console.log("view", row);
  };

  const edit = (_d) => {
    let val = _d.data[_d.row.index];
    setEditData(val);
    handleOpenModal();
  };
  const _delete = async ({ row }) => {
    // call delete api
    //console.log("_delete");
    const result = [];
    // await deteleDeliveryBoy(row.values._id);
    //console.log(result);
    tableRef.current.refreshTable();
  };
  const onPageIndexChange = (newPageIndex) => {
    setPageNumber(newPageIndex);
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(0); // Reset to the first page when page size changes
  };
  const navigateCallback = (orderId) => {
    navigate(`/view-managers/${orderId}`); // Replace with your desired path
  };
  const columnDef = DROPPOINTCOLUMNS(view, edit, _delete);

  return (
    <Container>
      <div className="btn-box py-3">
        <div className="d-flex justify-content-between">
          <div>
            <button
              className="btn btn-primary greeen-btn md_btn"
              onClick={handleOpenModal}
            >
              <span>
                <i className="mdi mdi-plus-circle-outline"></i>
              </span>{" "}
              {t("orderOutboxcomponents.createNew")}
            </button>
          </div>
          <div>
            {/* <Button
              aria-controls="export-menu"
              aria-haspopup="true"
              onClick={handleClick}
              // variant="contained"
              style={{ backgroundColor: "#6AA13C" }}
              className="btn btn-primary greeen-btn md_btn m-2 h-75"
              startIcon={<FileOutlineIcon />}
            >
              Export
            </Button> */}
            {/* <Menu
              id="export-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}>
                <DownloadButton
                  data={tableData}
                  filename="Business Unit.xlsx"
                  sheetname="Business Unit"
                  forModule="Business Unit"
                />
              </MenuItem>
            </Menu> */}

            <button
              className="btn btn-light grey-btn md_btn me-0"
              onClick={() => setIsFilterPanelOpen((prevState) => !prevState)}
            >
              <span>
                <i className="bi bi-funnel"></i>
              </span>{" "}
              {t("orderOutboxcomponents.filters")}
            </button>
          </div>
        </div>
      </div>
      <Card>
        <CardHeader>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setEditData();
              handleOpenModal();
            }}
          >
            + Add New
          </Button>
          <Container>
            <Grid container alignItems="center">
              <Grid item xs={12} sm={6}>
                {/* <PageTitle title="Delivery Boy" />
                 */}
                Managers List
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  // size="small"
                  placeholder="Search"
                  onChange={handleFilterSearch}
                  InputProps={{
                    startAdornment: <Icon>search</Icon>,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={3}></Grid>
            </Grid>
          </Container>
        </CardHeader>
        <CardContent>
          <MainTable
            columns={columnDef}
            data={tableData}
            initialPageSize={pageSize}
            pageNumber={pageNumber}
            onPageIndexChange={onPageIndexChange}
            onPageSizeChange={onPageSizeChange}
            enablePagination={true}
            totalRecords={totalRecords} // Pass the totalRecords to MainTable
            // className="custom-table-class"
            recordCountText="total records"
          />
          {/* <Paginated
            ref={tableRef}
            API={[]}
            // columns={DELIVERYBOYCOLUMNS({ view, edit, _delete, covidModel })}
          /> */}
        </CardContent>
      </Card>
      {/* zdsa */}
      <CardActionArea>
        <Dialog open={open} onClose={onCloseModal}>
          {/* <AddDeliveryBoy
            editData={editData}
            setOpen={setOpen}
            tableRef={tableRef}
          /> */}
        </Dialog>
        <Dialog open={open2} onClose={onCloseModal2}>
          {/* <CovidVaccinationReport
            covidVaccineData={covidVaccineData}
            setOpen={setOpen2}
          /> */}
        </Dialog>
      </CardActionArea>
    </Container>
  );
};

export default DropPoints;
